import { render, staticRenderFns } from "./addActivitiesView.vue?vue&type=template&id=483159e8&scoped=true"
import script from "./addActivitiesView.vue?vue&type=script&lang=js"
export * from "./addActivitiesView.vue?vue&type=script&lang=js"
import style0 from "./addActivitiesView.vue?vue&type=style&index=0&id=483159e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483159e8",
  null
  
)

export default component.exports